// extracted by mini-css-extract-plugin
module.exports = {"content":"style_content___VZ2F","tagList":"style_tagList__IjFlE","article-ads":"style_article-ads__BZQjD"};